import { Box, styled } from "@mui/material";

export const MainContainer = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: "100%",
});
